const updates = [
  {
    date: '07-30',
    title: '香蕉视频《繁花似锦》大结局更新',
    desc: '都市情感大剧迎来催泪收官，全网热议大结局剧情走向。',
    tag: '热播',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-29',
    title: '红桃视频上线三部好莱坞新片',
    desc: '动作、科幻、喜剧三大类型新片同步上架，周末观影选择更丰富。',
    tag: '上新',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-28',
    title: '蜜桃视频《长安锦绣》突破50亿播放',
    desc: '古装传奇剧持续霸榜，口碑与热度双丰收，续集已启动筹备。',
    tag: '里程碑',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-27',
    title: '西瓜视频美食纪录片专区上线',
    desc: '《风味人间》系列领衔，20部高分美食纪录片一次看过瘾。',
    tag: '上新',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-26',
    title: '樱桃视频悬疑剧场全面升级',
    desc: '新增4K画质选项，配合杜比音效，沉浸式追剧体验再提升。',
    tag: '升级',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-25',
    title: '糖豆视频少儿内容审核机制优化',
    desc: '新增家长控制功能，确保小朋友观看到的内容安全健康。',
    tag: '优化',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-24',
    title: '蘑菇视频与三大制片方达成合作',
    desc: '下半年将有超过30部独家影视作品陆续上线，敬请期待。',
    tag: '合作',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-23',
    title: '豆花视频搜索功能全面升级',
    desc: '支持剧名、演员、导演多维搜索，精准定位你想看的内容。',
    tag: '升级',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-22',
    title: '暑期档观影指南发布',
    desc: '涵盖各平台的暑期档追剧攻略，让你不错过任何一部好剧。',
    tag: '指南',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              最新快讯
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              豆花视频及各美食视频平台最新动态，追剧第一手资讯
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300/60 hidden sm:block"></div>

            <div className="space-y-6">
              {updates.map((item, idx) => (
                <div key={idx} className="flex gap-4 md:gap-6">
                  <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-1">
                    <div className="w-[38px] h-[38px] rounded-full bg-primary-100 border-4 border-background-50 flex items-center justify-center z-10 flex-shrink-0">
                      <i className="ri-arrow-right-up-line text-primary-600 text-xs"></i>
                    </div>
                  </div>

                  <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-primary-200 transition-colors duration-300">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">
                        {item.date}
                      </span>
                      <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}